import { camelizeKeys } from 'humps';

import { FileEvent } from '~/features/integrations/storage/ConfigurationDetailPanel/types';
import { pilot } from '~/services/serviceInstances';

interface Request {
  syncPair: string;
  clientId: number;
}

//TODO: replace with codecash for FileEvent
type ServerResponse = {
  data: {
    id: string;
    type: string;
    attributes: {
      /** Unique identifier for the file event */
      id: string;
      /** Trace identifier for tracking related events */
      trace_id: string;
      /** Client identifier */
      client_id: number;
      /** Sub-domain identifier */
      sub_domain: string;
      /** Name of the file involved in the event */
      filename: string;
      /** Source path of the file (nullable for create operations) */
      from_path: string | null;
      /** Destination path of the file */
      to_path: string;
      /** Direction of the operation */
      direction: string;
      /** Type of operation performed */
      operation_type: string;
      /** Sync Provider */
      provider: string;
      /** Identifier for the sync pair */
      sync_pair_id: string;
      /** Timestamp when the event occurred */
      timestamp: string;
      /** Error code if the operation failed (nullable) */
      error_code: string | null;
      /** Detailed error message if the operation failed (nullable) */
      error_details: string | null;
    };
  }[];
  meta: {
    count: number;
  };
};

export const getFileLevelEvents = async ({
  syncPair,
  clientId,
}: Request): Promise<{
  count: number;
  results: FileEvent[];
}> => {
  const param = `?filter[client_id]=${clientId}`;
  const response: ServerResponse = await pilot.get(
    `/evisync/sync/${syncPair}/file-events${param}`,
  );

  return mapToPropResponse(response);
};

const mapToPropResponse = (
  response: ServerResponse,
): {
  count: number;
  results: FileEvent[];
} => {
  return {
    count: response.meta.count,
    results: response.data.map((item) => {
      const camelizedAttrs = camelizeKeys(item.attributes);
      return {
        id: item.id,
        ...camelizedAttrs,
      } as FileEvent;
    }),
  };
};
